import NamedDto from 'modules/base/dto/NamedDto';

export class AspectInputAttributeEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.type = null;
		/** @type {string} */
		this.value = null;
		/** @type {string} */
		this.attributeClass = null;
		/** @type {string} */
		this.modelFieldName = null;
	}

	/**
	 * @typedef {Object} _AspectInputAttributeEditDtoProps
	 * @property {string} type
	 * @property {string} value
	 * @property {string} attributeClass
	 * @property {string} modelFieldName
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _AspectInputAttributeEditDtoProps} AspectInputAttributeEditDtoProps
	 */
	/**
	 *
	 * @param {AspectInputAttributeEditDtoProps} props
	 * @returns {AspectInputAttributeEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.type = props.type;
		this.value = props.value;
		this.attributeClass = props.attributeClass;
		this.modelFieldName = props.modelFieldName;
		return this;
	}
}

export default AspectInputAttributeEditDto;
